import { selectSalesIntelligenceState } from "app/pages/sales-intelligence/store/selectors";
import { createStatePropertySelector } from "app/pages/workspace/sales/helpers";

const select = createStatePropertySelector(selectSalesIntelligenceState("assignToUsers"));

export const selectAssignableUsers = select("users");
export const selectAssignableUsersAreBeingFetched = select("areUsersBeingFetched");
export const selectAssignIsInProgress = select("isAssignInProgress");
export const selectIsShowAssignToUserModal = select("isShowAssignToUserModal");
